var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1416 2.92578C7.38328 2.92578 5.14162 5.16745 5.14162 7.92578V10.3341C5.14162 10.8424 4.92495 11.6174 4.66662 12.0508L3.70828 13.6424C3.11662 14.6258 3.52495 15.7174 4.60828 16.0841C8.19995 17.2841 12.075 17.2841 15.6666 16.0841C16.675 15.7508 17.1166 14.5591 16.5666 13.6424L15.6083 12.0508C15.3583 11.6174 15.1416 10.8424 15.1416 10.3341V7.92578C15.1416 5.17578 12.8916 2.92578 10.1416 2.92578Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6833 3.16719C11.425 3.09219 11.1583 3.03385 10.8833 3.00052C10.0833 2.90052 9.31664 2.95885 8.59998 3.16719C8.84164 2.55052 9.44164 2.11719 10.1416 2.11719C10.8416 2.11719 11.4416 2.55052 11.6833 3.16719Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6417 16.3828C12.6417 17.7578 11.5167 18.8828 10.1417 18.8828C9.45839 18.8828 8.82506 18.5995 8.37506 18.1495C7.92506 17.6995 7.64172 17.0661 7.64172 16.3828",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c54a0cbe97b13046939d182796db5b2f.svg";
export { ForwardRef as ReactComponent };